<!-- 收益趋势 -->
<template>
    <div class="a-mt-36">
        <div class="a-flex-rsbc">
            <div class="a-flex-rfsfe">
                <span class="a-c-master a-fw-700 a-fs-16">毛豆消耗趋势</span>
            </div>
            <le-date-range 
                @change="dateChange"
                ref="dateRange"
                :pickerOptions="pickerOptions" 
                :minDate.sync="queryStartDate" 
                :maxDate.sync="queryEndDate" 
                :defaultTime="['00:00:00','23:59:59']"
                valueFormat="yyyy-MM-dd HH:mm:ss" />
        </div>
        <div id="mychartPoint" class="mychart"></div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                queryStartDate: '',
                queryEndDate: '',
                moneyNum: '',//
                orderNum: '',
                transition: '',
                params_req: '',
                choiceDate: '',
                pickerOptions: {
                    onPick: ({ maxDate, minDate }) => {
                        this.choiceDate = minDate.getTime()
                        if (maxDate) {
                            this.choiceDate = ''
                        }
                    },
                    disabledDate: (time) => {
                        if (this.choiceDate) {
                            let one = 31 * 24 * 3600 * 1000
                            const minTime = this.choiceDate - one
                            const maxTime = this.choiceDate + one
                            return time.getTime() < minTime || time.getTime() > maxTime
                        }else{
                            return ''
                        }
                    },
                },
            }
        },
        created () {
            
        },
        props: ['id','params','infoType'],
        watch:{
            params:{
                immediate: true,
                handler (val) {                    
                    this.params_req = JSON.parse(JSON.stringify(val))
                    this.$nextTick(()=>{
                        if(this.infoType == 'province' || this.infoType == 'city'){
                            this.queryStartDate = this.$getDay.getTodayBeforeDays(31) + ' 00:00:00'
                            this.queryEndDate = this.$getDay.getTodayBeforeDays(1) + ' 23:59:59'
                        }else{
                            this.queryStartDate = this.$getDay.getTodayBeforeDays(30) + ' 00:00:00'
                            this.queryEndDate = this.$getDay.getTodayBeforeDays(0) + ' 23:59:59'
                        }
                        this.$refs['dateRange'].value1 = [this.queryStartDate, this.queryEndDate]
                        this.getChartData()
                    })
                }
            }
        },
        filters:{
            initMoney (val) {
                var num = Number(val);
                if(!num){//等于0
                    return num+'.00';
                }else{//不等于0
                    num = Math.round((num)*100)/10000;
                    num = num.toFixed(2);
                    num+='';//转成字符串
                    var reg=num.indexOf('.') >-1 ? /(\d{1,3})(?=(?:\d{3})+\.)/g : /(\d{1,3})(?=(?:\d{3})+$)/g;//千分符的正则
                // console.log(num.indexOf('.')>-1)
                    return num.replace(reg, '$1,')//千分位格式化
                }
            }
        },
        methods:{
            dateChange () {
                this.getChartData()
            },
            setMoney (val) {
                var num = Number(val);
                if(!num){//等于0
                    return num+'.00';
                }else{//不等于0
                    // num = Math.round((num)*100)/10000;
                    // num = num.toFixed(2);
                    num+='';//转成字符串
                    var reg=num.indexOf('.') >-1 ? /(\d{1,3})(?=(?:\d{3})+\.)/g : /(\d{1,3})(?=(?:\d{3})+$)/g;//千分符的正则
                // console.log(num.indexOf('.')>-1)
                    return num.replace(reg, '$1,')//千分位格式化
                }
            },
            drawChart (xAxis=[], points=[], refoundPoints=[]) { //横坐标, 收益金额，订单数量，交易额
                var chartDom = document.getElementById('mychartPoint');
                var option;
                option = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    color: ['#FFA900','#67C23A','#6699FF'],
                    legend: {
                        itemWidth: 8,
                        itemHeight: 8,
                        right: "2%",
                        itemGap: 40
                    },
                    grid: {
                        left: '0',
                        right: '0',
                        bottom: '0',
                        top: '36px',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        min: 0,
                        axisLine: {
                            lineStyle: {
                                color: '#DDDDDD'
                            }
                        },
                        axisTick: {
                            lineStyle: {
                                color: '#DDDDDD'
                            }
                        },
                        splitLine:{
                            show:false
                        },
                        axisLabel:{
                            color: '#999999',
                            showMaxLabel: true,
                            formatter: function (value, index) {
                                let arr = value.split('-')
                                return arr[1]+'-'+arr[2];
                            }
                        },
                        data: xAxis
                    },
                    yAxis: {
                        type: 'value',
                        max: 'dataMax',
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false,
                        },
                        splitLine:{
                            lineStyle:{
                                color: '#EEEEEE',
                                type: 'dashed'
                            }
                        },
                    },
                    series: [
                        {
                            name: '毛豆消耗',
                            data: points,
                            type: 'line',
                            lineStyle:{
                                normal:{
                                    color: '#FFA900',
                                    width: 2
                                }
                            },
                            smooth: true
                        },
                        {
                            name: '毛豆退款',
                            data: refoundPoints,
                            type: 'line',
                            lineStyle:{
                                normal:{
                                    color: '#67C23A',
                                    width: 2
                                }
                            },
                            smooth: true
                        },
                    ]
                };
                var myChart = this.$echarts.init(chartDom);
                myChart.clear()
                myChart.setOption(option,true);
            },
            // 获取图表数据
            getChartData () {
                if(this.infoType == 'business'){
					apiUrl = this.$Config.apiUrl.getAnalysisPointsTrendBusiness
				}else if(this.infoType == 'income'){
					apiUrl = this.$Config.apiUrl.getAnalysisPointsTrendIncome
				}else if(this.infoType == 'station'){
					apiUrl = this.$Config.apiUrl.getAnalysisPointsTrendStation
				}else if(this.infoType == 'province'){
					// apiUrl = this.$Config.apiUrl.getAnalysisIncomeTrendCity
				}else if(this.infoType == 'city'){
					// apiUrl = this.$Config.apiUrl.getAnalysisIncomeTrendCity
				}

                let apiUrl
                if(this.infoType == 'business'){
                    apiUrl = this.$Config.apiUrl.getAnalysisPointsTrendBusiness
                }else if(this.infoType == 'income'){
                    apiUrl = this.$Config.apiUrl.getAnalysisPointsTrendIncome
                }else if(this.infoType == 'station'){
                    apiUrl = this.$Config.apiUrl.getAnalysisPointsTrendStation
                }else if(this.infoType == 'province'){
                    // apiUrl = this.$Config.apiUrl.getAnalysisIncomeTrendCity
                }else if(this.infoType == 'city'){
                    // apiUrl = this.$Config.apiUrl.getAnalysisIncomeTrendCity
                }
                this.$Axios._post({
                    url: apiUrl,
                    method: "post",
                    showLoading: false,
                    params: {
                        ...this.params_req,
                        startDay: this.queryStartDate,
                        endDay: this.queryEndDate,
                        startTime: this.queryStartDate,
                        endTime: this.queryEndDate
                    }
                }).then(res => {
                    if(res.result.code == 0){           
                        let dateArr
                        if(res.result.data.length){
                            dateArr = res.result.data
                        }else{
                            dateArr = this.$getDay.enumerateDaysBetweenDates(this.queryStartDate,this.queryEndDate).map(item=>{
                                return {
                                    day: item,
                                    points: 0,
                                    pointsRefund: 0,
                                }
                            })
                        }
                        let xAxis = []
                        let points = []
                        let pointsRefund = []
                        dateArr.map(item=>{
                            xAxis.push(item.day)
                            points.push(item.points || 0)
                            pointsRefund.push(item.pointsRefund || 0)
                        })
                        console.log(points,pointsRefund);

                        this.drawChart(xAxis, points, pointsRefund)
                    }else{
                        this.$message.error(res.result.message)
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.tips3{
    width: 11px;
    height: 11px;
    background: #67C23A;
    border-radius: 3px;
}
.tips2{
    width: 11px;
    height: 11px;
    background: #FFA900;
    border-radius: 3px;
}
.tips{
    width: 11px;
    height: 11px;
    background: #6699FF;
    border-radius: 3px;
}
.mychart{
    width: 100%;
    height: 300px;
}
.tooltips{
    background: #FFFFFF;
    box-shadow: 0px 5px 21px 0px rgba(139,147,167,0.25);
    opacity: 0.96;
}
.tooltipsTitle{
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606366;
    line-height: 27px;
    padding: 0 25px;
}
.tooltipsContent{
    font-size: 21px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #303133;
    line-height: 32px;
}
</style>